"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-four/sections/faqSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FaqSectionAccordions2Item = {
    key: Key | null | undefined;
    /** Detected variants: "headingFour" | "headingFive" */
    ariaLabelledby: string;
    /** Detected variants: "collapseFour" | "collapseFive" */
    id: string;
    /** Detected variants: "headingFour" | "headingFive" */
    h20Id: string;
    /** Detected variants: "Do you offer vaccinations at your clinic?" | "Do you offer any Consultation Procedures?" */
    link0Text: ReactNode;
    /** Detected variants: "collapseFour" | "collapseFive" */
    ariaControls: string;
    /** Detected variants: "#collapseFour" | "#collapseFive" */
    dataBsTarget: string;
    /** Detected variants: "accordion-item" */
    className?: string;
    /** Detected variants: "accordion-collapse collapse" */
    div0ClassName?: string;
    /** Detected variants: "#faq-details" */
    dataBsParent?: string;
    /** Detected variants: "accordion-body" */
    div0ClassName2?: string;
    /** Detected variants: "accordion-content" */
    div0ClassName3?: string;
    /** Detected variants: "Regular checkups are recommended every few months during infancy, then once a year for older children. These visits help monitor growth, development, and vaccinations." */
    p0Text?: ReactNode;
    /** Detected variants: "accordion-header" */
    h20ClassName?: string;
    /** Detected variants: "false" */
    ariaExpanded?: boolean;
    /** Detected variants: "accordion-button collapsed" */
    link0ClassName?: string;
    /** Detected variants: "collapse" */
    dataBsToggle?: string;
    /** Detected variants: "#" */
    href?: string;
};

type FaqSectionFormWrapsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Name" | "Email" */
    placeholder: string;
    /** Detected variants: "form-wrap" */
    className?: string;
    /** Detected variants: "form-control" */
    input0ClassName?: string;
    /** Detected variants: "text" | "email" */
    input0Type: string;
};

type FaqSectionAccordionsItem = {
    key: Key | null | undefined;
    /** Detected variants: "headingOne" | "headingTwo" | "headingThree" */
    ariaLabelledby: string;
    /** Detected variants: "accordion-collapse collapse show" | "accordion-collapse collapse" */
    className: string;
    /** Detected variants: "collapseOne" | "collapseTwo" | "collapseThree" */
    id: string;
    /** Detected variants: "headingOne" | "headingTwo" | "headingThree" */
    h30Id: string;
    /** Detected variants: "What age group do you provide care for?" | "How often should my child visit a pediatrician?" | "Can I book an online consultation?" */
    link0Text: ReactNode;
    /** Detected variants: "collapseOne" | "collapseTwo" | "collapseThree" */
    ariaControls: string;
    /** Detected variants: "true" | "false" */
    ariaExpanded: boolean;
    /** Detected variants: "accordion-button" | "accordion-button collapsed" */
    link0ClassName: string;
    /** Detected variants: "#collapseOne" | "#collapseTwo" | "#collapseThree" */
    dataBsTarget: string;
    /** Detected variants: "accordion-item" */
    divClassName?: string;
    /** Detected variants: "#faq-details" */
    dataBsParent?: string;
    /** Detected variants: "accordion-body" */
    div0ClassName?: string;
    /** Detected variants: "accordion-content" */
    div0ClassName2?: string;
    /** Detected variants: "Regular checkups are recommended every few months during infancy, then once a year for older children. These visits help monitor growth, development, and vaccinations." */
    p0Text?: ReactNode;
    /** Detected variants: "accordion-header" */
    h30ClassName?: string;
    /** Detected variants: "collapse" */
    dataBsToggle?: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeFourFaqSectionGeneratedProps = {
    divH20H2Props?: Partial<ComponentProps<"h2">> | ((item: FaqSectionAccordions2Item) => Partial<ComponentProps<"h2">>);
    divH20Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FaqSectionAccordions2Item) => Partial<ComponentProps<typeof SmartLink>>);
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: FaqSectionAccordionsItem) => Partial<ComponentProps<"h3">>);
    divH30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FaqSectionAccordionsItem) => Partial<ComponentProps<typeof SmartLink>>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "Our Faq’s" */
    sectionDiv0Div0Div0Div0Div0DivText?: ReactNode;
    /** Default: "Frequently Asked" */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Questions" */
    sectionDiv0Div0Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "faq-details" */
    sectionDiv0Div0Div0Div1DivId?: string;
    /** Default: "Make an Appointment" */
    sectionDiv0Div0Div1Div0Div0Button0ButtonText?: ReactNode;
    sectionDiv0Div0Div1Div0Div0Button0ButtonVisible?: boolean;
    sectionDiv0Div0Div1Div0Div0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "dd/mm/yyyy" */
    sectionDiv0Div0Div1Div0Div0Div3Div0CommonDatePicker0CommonDatePickerPlaceholder?: string;
    /** Default: "Need help? We’re just call away." */
    sectionDiv0Div0Div1Div0Div0H30H3Text?: ReactNode;
    sectionDiv0Div0Div1Div0Div0H30H3Visible?: boolean;
    sectionDiv0Div0Div1Div0Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "bg" */
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/appointment-bg.png" */
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/appointment-bg-02.png" */
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/faq-bg-01.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/about-bg-03.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    faqSectionAccordions2: FaqSectionAccordions2Item[];
    faqSectionFormWraps: FaqSectionFormWrapsItem[];
    faqSectionAccordions: FaqSectionAccordionsItem[];
    faqSectionAccordions2ItemWrapper?: (item: FaqSectionAccordions2Item, content: ReactNode) => ReactNode;
    faqSectionAccordions2Renderer?: (defaultNode: ReactNode) => ReactNode;
    faqSectionAccordions2LinkVisible?: boolean;
    faqSectionAccordions2LinkRenderer?: (item: FaqSectionAccordions2Item, defaultNode: ReactNode) => ReactNode;
    faqSectionAccordions2H2Visible?: boolean;
    faqSectionAccordions2H2Renderer?: (item: FaqSectionAccordions2Item, defaultNode: ReactNode) => ReactNode;
    faqSectionAccordions2LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FaqSectionAccordions2Item) => Partial<ComponentProps<typeof SmartLink>>);
    faqSectionAccordions2H2Props?: Partial<ComponentProps<"h2">> | ((item: FaqSectionAccordions2Item) => Partial<ComponentProps<"h2">>);
    faqSectionFormWrapsItemWrapper?: (item: FaqSectionFormWrapsItem, content: ReactNode) => ReactNode;
    faqSectionFormWrapsRenderer?: (defaultNode: ReactNode) => ReactNode;
    faqSectionAccordionsItemWrapper?: (item: FaqSectionAccordionsItem, content: ReactNode) => ReactNode;
    faqSectionAccordionsRenderer?: (defaultNode: ReactNode) => ReactNode;
    faqSectionAccordionsLinkVisible?: boolean;
    faqSectionAccordionsLinkRenderer?: (item: FaqSectionAccordionsItem, defaultNode: ReactNode) => ReactNode;
    faqSectionAccordionsH3Visible?: boolean;
    faqSectionAccordionsH3Renderer?: (item: FaqSectionAccordionsItem, defaultNode: ReactNode) => ReactNode;
    faqSectionAccordionsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FaqSectionAccordionsItem) => Partial<ComponentProps<typeof SmartLink>>);
    faqSectionAccordionsH3Props?: Partial<ComponentProps<"h3">> | ((item: FaqSectionAccordionsItem) => Partial<ComponentProps<"h3">>);
};

const HomeFourFaqSectionGenerated: FC<HomeFourFaqSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0DivText = "Our Faq’s",
    sectionDiv0Div0Div0Div0H20H2Text = "Frequently Asked",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div0H20Span0SpanText = "Questions",
    sectionDiv0Div0Div0Div1DivId = "faq-details",
    sectionDiv0Div0Div1Div0Div0Button0ButtonText = "Make an Appointment",
    sectionDiv0Div0Div1Div0Div0Button0ButtonVisible,
    sectionDiv0Div0Div1Div0Div0Button0ButtonRenderer,
    sectionDiv0Div0Div1Div0Div0Button0ButtonProps,
    sectionDiv0Div0Div1Div0Div0Div3Div0CommonDatePicker0CommonDatePickerPlaceholder = "dd/mm/yyyy",
    sectionDiv0Div0Div1Div0Div0H30H3Text = "Need help? We’re just call away.",
    sectionDiv0Div0Div1Div0Div0H30H3Visible,
    sectionDiv0Div0Div1Div0Div0H30H3Renderer,
    sectionDiv0Div0Div1Div0Div0H30H3Props,
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageAlt = "bg",
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/appointment-bg.png",
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt = "bg",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/appointment-bg-02.png",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps,
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/faq-bg-01.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "bg",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/about-bg-03.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divH20H2Props,
    divH20Link0LinkProps,
    divH30H3Props,
    divH30Link0LinkProps,
    sectionDiv0Div0ClassName,
    faqSectionAccordions2,
    faqSectionFormWraps,
    faqSectionAccordions,
    faqSectionAccordions2ItemWrapper,
    faqSectionAccordions2Renderer,
    faqSectionAccordions2LinkVisible,
    faqSectionAccordions2LinkRenderer,
    faqSectionAccordions2H2Visible,
    faqSectionAccordions2H2Renderer,
    faqSectionAccordions2LinkProps,
    faqSectionAccordions2H2Props,
    faqSectionFormWrapsItemWrapper,
    faqSectionFormWrapsRenderer,
    faqSectionAccordionsItemWrapper,
    faqSectionAccordionsRenderer,
    faqSectionAccordionsLinkVisible,
    faqSectionAccordionsLinkRenderer,
    faqSectionAccordionsH3Visible,
    faqSectionAccordionsH3Renderer,
    faqSectionAccordionsLinkProps,
    faqSectionAccordionsH3Props,
}) => {
    return (
        <section className="faq-section-four section">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row align-items-center g-4"}>
                    <div className="col-lg-7">
                        <div className="section-header section-header-four">
                            <div className="section-sub-title">{sectionDiv0Div0Div0Div0Div0DivText}</div>
                            {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                <h2 className="section-title" {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>
                                    {sectionDiv0Div0Div0Div0H20H2Text}
                                    <span>{sectionDiv0Div0Div0Div0H20Span0SpanText}</span>
                                </h2>
                            ))}
                        </div>
                        <div className="accordion faq-accordion" id={sectionDiv0Div0Div0Div1DivId}>
                            {renderCollectionNode(
                                faqSectionAccordions,
                                (item: FaqSectionAccordionsItem) => (
                                    <div className={item.divClassName ?? "accordion-item"} key={item.key}>
                                        {renderItemNode(faqSectionAccordionsH3Visible, faqSectionAccordionsH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "accordion-header"} id={item.h30Id} {...(typeof faqSectionAccordionsH3Props === "function" ? faqSectionAccordionsH3Props(item) : (faqSectionAccordionsH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>
                                                {renderItemNode(faqSectionAccordionsLinkVisible, faqSectionAccordionsLinkRenderer, item, (
                                                    <SmartLink href={item.href ?? "#"} className={item.link0ClassName} data-bs-toggle={item.dataBsToggle ?? "collapse"} data-bs-target={item.dataBsTarget} aria-expanded={item.ariaExpanded} aria-controls={item.ariaControls} {...(typeof faqSectionAccordionsLinkProps === "function" ? faqSectionAccordionsLinkProps(item) : (faqSectionAccordionsLinkProps ?? {}))} {...(typeof divH30Link0LinkProps === "function" ? divH30Link0LinkProps(item) : (divH30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                        <div id={item.id} className={item.className} aria-labelledby={item.ariaLabelledby} data-bs-parent={item.dataBsParent ?? "#faq-details"}>
                                            <div className={item.div0ClassName ?? "accordion-body"}>
                                                <div className={item.div0ClassName2 ?? "accordion-content"}>
                                                    <p>{item.p0Text ?? "Regular checkups are recommended every few months during infancy, then once a year for older children. These visits help monitor growth, development, and vaccinations."}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ),
                                faqSectionAccordionsItemWrapper,
                                faqSectionAccordionsRenderer
                            )}
                            {renderCollectionNode(
                                faqSectionAccordions2,
                                (item: FaqSectionAccordions2Item) => (
                                    <div className={item.className ?? "accordion-item"} key={item.key}>
                                        {renderItemNode(faqSectionAccordions2H2Visible, faqSectionAccordions2H2Renderer, item, (
                                            <h2 className={item.h20ClassName ?? "accordion-header"} id={item.h20Id} {...(typeof faqSectionAccordions2H2Props === "function" ? faqSectionAccordions2H2Props(item) : (faqSectionAccordions2H2Props ?? {}))} {...(typeof divH20H2Props === "function" ? divH20H2Props(item) : (divH20H2Props ?? {}))}>
                                                {renderItemNode(faqSectionAccordions2LinkVisible, faqSectionAccordions2LinkRenderer, item, (
                                                    <SmartLink href={item.href ?? "#"} className={item.link0ClassName ?? "accordion-button collapsed"} data-bs-toggle={item.dataBsToggle ?? "collapse"} data-bs-target={item.dataBsTarget} aria-expanded={item.ariaExpanded ?? false} aria-controls={item.ariaControls} {...(typeof faqSectionAccordions2LinkProps === "function" ? faqSectionAccordions2LinkProps(item) : (faqSectionAccordions2LinkProps ?? {}))} {...(typeof divH20Link0LinkProps === "function" ? divH20Link0LinkProps(item) : (divH20Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h2>
                                        ))}
                                        <div id={item.id} className={item.div0ClassName ?? "accordion-collapse collapse"} aria-labelledby={item.ariaLabelledby} data-bs-parent={item.dataBsParent ?? "#faq-details"}>
                                            <div className={item.div0ClassName2 ?? "accordion-body"}>
                                                <div className={item.div0ClassName3 ?? "accordion-content"}>
                                                    <p>{item.p0Text ?? "Regular checkups are recommended every few months during infancy, then once a year for older children. These visits help monitor growth, development, and vaccinations."}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ),
                                faqSectionAccordions2ItemWrapper,
                                faqSectionAccordions2Renderer
                            )}
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="appointment-form">
                            <div className="appointment-content">
                                {renderNode(sectionDiv0Div0Div1Div0Div0H30H3Visible, sectionDiv0Div0Div1Div0Div0H30H3Renderer, (
                                    <h3 {...(sectionDiv0Div0Div1Div0Div0H30H3Props ?? {})}>{sectionDiv0Div0Div1Div0Div0H30H3Text}</h3>
                                ))}
                                {renderCollectionNode(
                                    faqSectionFormWraps,
                                    (item: FaqSectionFormWrapsItem) => (
                                        <div className={item.className ?? "form-wrap"} key={item.key}>
                                            <input type={item.input0Type} className={item.input0ClassName ?? "form-control"} placeholder={item.placeholder} />
                                        </div>
                                    ),
                                    faqSectionFormWrapsItemWrapper,
                                    faqSectionFormWrapsRenderer
                                )}
                                <div className="form-wrap">
                                    <div className="select select-four" data-template-tag="CommonSelect" />
                                </div>
                                <div className="form-wrap">
                                    <div className="form-icon">
                                        <div data-template-tag="CommonDatePicker" />
                                    </div>
                                </div>
                                <div className="form-wrap">
                                    <div className="form-icon">
                                        <div data-template-tag="CommonTimePicker" />
                                    </div>
                                </div>
                                {renderNode(sectionDiv0Div0Div1Div0Div0Button0ButtonVisible, sectionDiv0Div0Div1Div0Div0Button0ButtonRenderer, (
                                    <button type="submit" className="btn btn-primary w-100" {...(sectionDiv0Div0Div1Div0Div0Button0ButtonProps ?? {})}>{sectionDiv0Div0Div1Div0Div0Button0ButtonText}</button>
                                ))}
                                {renderNode(sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageAlt} className="appointment-bg-01" {...(sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </div>
                            {renderNode(sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt} className="appointment-bg-02" {...(sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="faq-bg-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="faq-bg-02" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeFourFaqSectionGenerated;
